import { FC } from "react";
import style from "./TopCard.module.scss";
import Typhography from "../../../../shared/Typhography/Typhography";
import { Icon } from "@phosphor-icons/react";
import {
  AbsoluteCenter,
  HStack,
  ProgressCircle,
  SkeletonCircle,
  SkeletonText,
} from "@chakra-ui/react";
import { AnimatedCounter } from "react-animated-counter";
import cx from "classnames";
export const TopCard: FC<{
  Icon: Icon;
  label: string;
  sublabel: string;
  percentage: number;
  isLoading?: boolean;
  labelCircle?: number;
  creatingPdf: boolean;
  showPercentageLabelCircle?: boolean;
  delta?: number | null;
  deltaUnit?: string;
  /**
   * `inverted` per le metriche in cui alto = male (Stress).
   *
   * L'anello era sempre verde: uno stress al 75% veniva disegnato come un
   * recupero al 75%, cioè "va bene". Tre card in fila, due significati
   * opposti, lo stesso colore.
   */
  tone?: "positive" | "inverted";
}> = ({
  Icon,
  label,
  sublabel,
  percentage,
  labelCircle,
  creatingPdf,
  isLoading,
  showPercentageLabelCircle = true,
  delta,
  deltaUnit = "",
  tone = "positive",
}) => {
  /** Soglie allineate al badge Basso/Medio/Alto dello stress (scala 1-5). */
  const circleClass = cx(style.progressCircle, {
    [style.progressCircleCritical]:
      tone === "inverted" && typeof labelCircle === "number" && labelCircle > 50,
    [style.progressCircleInverted]:
      tone === "inverted" &&
      typeof labelCircle === "number" &&
      labelCircle > 25 &&
      labelCircle <= 50,
  });
  return (
    <div className={style.topCard}>
      {isLoading ? (
        <HStack width="full" height="full">
          <SkeletonText noOfLines={2} w={140} />
          <SkeletonCircle size="16" />
        </HStack>
      ) : (
        <>
          <div className="d-flex align-items-center gap-2">
            <Icon className={style.icon} />
            <div className="d-flex flex-column gap-1">
              <Typhography size="bold-16">{label}</Typhography>
              <Typhography className={style.sublabel}>{sublabel}</Typhography>
              {typeof delta === "number" && (
                <div
                  className={cx(style.deltaBadge, {
                    [style.deltaPositive]: delta >= 0,
                    [style.deltaNegative]: delta < 0,
                  })}
                >
                  <Typhography size="bold-12">
                    {delta >= 0 ? `▲ +${delta}` : `▼ ${delta}`}{deltaUnit}
                  </Typhography>
                </div>
              )}
            </div>
          </div>
          <ProgressCircle.Root
            size={"xl"}
            value={percentage}
            className={circleClass}
          >
            <ProgressCircle.Circle>
              <ProgressCircle.Track />
              <ProgressCircle.Range />
            </ProgressCircle.Circle>
            <AbsoluteCenter>
              {/* <AnimatedCounter includeDecimals={false} value={1} /> */}
              {/* <Typhography size="bold-16">{labelCircle}</Typhography> */}
              <div className="d-flex align-items-center">
                {typeof labelCircle === "number" ? (
                  <>
                    {creatingPdf ? (
                      <Typhography size="bold-16">
                        {labelCircle.toFixed(0)}
                      </Typhography>
                    ) : (
                      <AnimatedCounter
                        containerStyles={{ margin: 0 }}
                        includeDecimals={false}
                        fontSize={"16px"}
                        digitStyles={{
                          fontWeight: 700,
                        }}
                        value={labelCircle}
                      ></AnimatedCounter>
                    )}
                    {showPercentageLabelCircle && (
                      <Typhography size="bold-16">%</Typhography>
                    )}
                  </>
                ) : (
                  <Typhography size="bold-16">-</Typhography>
                )}
              </div>
            </AbsoluteCenter>
          </ProgressCircle.Root>
        </>
      )}
    </div>
  );
};
